import { useSelector } from 'react-redux';
import { map } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { palette } from '@dev/ee-components';
import { ApplicationState } from '@api/store';
import { PieChartsDataType } from '../../DeviceDetailsInterface';

export const usePieChartsData = (): PieChartsDataType => {
    const { deviceDetailsStats, loading } = useSelector((state: ApplicationState) => state.deviceDetails);
    const { t } = useTranslation();

    const pieChartDataOpened = [];
    const pieChartDataClicked = [];
    const pieChartDataUnsubscribed = [];

    if (loading) {
        return { pieChartDataOpened, pieChartDataClicked, pieChartDataUnsubscribed };
    }

    const chartColor = [palette.indigo[8], palette.indigo[5], palette.indigo[3], palette.indigo[2]];

    map(deviceDetailsStats, (item, index) => {
        item?.OpenCount &&
            pieChartDataOpened.push({
                name: item.FormFactorName,
                value: item.OpenCount,
                percent: item.OpenRate,
                color: chartColor[index],
                label: t('opened'),
            });
        item.ClickCount &&
            pieChartDataClicked.push({
                name: item.FormFactorName,
                value: item.ClickCount,
                percent: item.ClickRate,
                color: chartColor[index],
                label: t('clicked'),
            });
        item.UnsubscribeCount &&
            pieChartDataUnsubscribed.push({
                name: item.FormFactorName,
                value: item.UnsubscribeCount,
                percent: item.UnsubscribeRate,
                color: chartColor[index],
                label: t('unsubscribed'),
            });
    });

    return {
        pieChartDataOpened,
        pieChartDataClicked,
        pieChartDataUnsubscribed,
    };
};
